class SortingSelect extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector("select");
    if (!this.select) return;

    this.select.addEventListener("change", this.onChange.bind(this));
  }

  async onChange() {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", this.select.value);
    url.searchParams.delete("page");

    const productGrid = document.querySelector("#ProductGridContainer");
    const section = productGrid?.closest('[id^="shopify-section-"]');

    if (!section) {
      window.location.href = url.toString();
      return;
    }

    const sectionId = section.id.replace("shopify-section-", "");
    url.searchParams.set("section_id", sectionId);

    try {
      const res = await fetch(url);
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // 🔥 lấy cả section (KHÔNG phụ thuộc grid id)
      const newSection = doc.querySelector(`#${section.id}`);
      const currentSection = document.getElementById(section.id);

      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;
        window.history.pushState({}, "", url.toString());
      } else {
        console.warn("Không tìm thấy section trong response");
        window.location.href = url.toString();
      }
    } catch (e) {
      console.error(e);
      window.location.href = url.toString();
    }
  }
}

customElements.define("sorting-select", SortingSelect);